var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        id: "recommended-vehicle-model-offer",
        title: "Send Vehicle Offer",
        "no-fade": "",
        size: "lg"
      },
      on: {
        change: _vm.onModalChange,
        hide: _vm.onModalHide,
        show: _vm.onModalChange
      },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function() {
            return [
              _c(
                "b-btn",
                {
                  on: {
                    click: function($event) {
                      _vm.modalOpen = false
                    }
                  }
                },
                [_vm._v("Cancel")]
              ),
              _vm._v(" "),
              _c(
                "b-btn",
                {
                  attrs: {
                    disabled: !_vm.selectedUserIds.length
                      ? _vm.customRecipients === ""
                        ? true
                        : false
                      : false,
                    title: _vm.selectedUserIds.length
                      ? ""
                      : "Add some users to send."
                  },
                  on: {
                    click: function($event) {
                      return _vm.submitOffer()
                    }
                  }
                },
                [_vm._v("Send")]
              )
            ]
          },
          proxy: true
        }
      ]),
      model: {
        value: _vm.modalOpen,
        callback: function($$v) {
          _vm.modalOpen = $$v
        },
        expression: "modalOpen"
      }
    },
    [
      _vm._v(" "),
      _vm.recommend
        ? [
            _c("span", { staticClass: "checkbox" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.notify,
                    expression: "notify"
                  }
                ],
                attrs: { type: "checkbox", name: "notify", id: "notify" },
                domProps: {
                  checked: Array.isArray(_vm.notify)
                    ? _vm._i(_vm.notify, null) > -1
                    : _vm.notify
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.notify,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.notify = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.notify = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.notify = $$c
                    }
                  }
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "notify" } }, [
                _vm._v("Also notify customers by email")
              ])
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("label", [_vm._v("\n            Offer email subject\n        ")]),
          _vm._v(" "),
          _c("b-form-input", {
            staticClass: "mb-2",
            attrs: {
              id: "offer_subject_send",
              type: "text",
              placeholder: _vm.offer_subject_placeholder
            },
            model: {
              value: _vm.offer_subject,
              callback: function($$v) {
                _vm.offer_subject = $$v
              },
              expression: "offer_subject"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", [
        _vm._v(
          "\n        Select the people you want to offer this car to.\n    "
        )
      ]),
      _vm._v(" "),
      _vm.notify
        ? _c("div", {}, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-md-12" },
                [
                  _vm.editTemplate
                    ? [
                        _c("small", {
                          domProps: { innerHTML: _vm._s(_vm.instructions) }
                        }),
                        _vm._v(" "),
                        _c("editor", {
                          attrs: {
                            "api-key": _vm.TINYMCE_API_KEY,
                            init: _vm.editor_settings
                          },
                          model: {
                            value: _vm.main_content,
                            callback: function($$v) {
                              _vm.main_content = $$v
                            },
                            expression: "main_content"
                          }
                        })
                      ]
                    : _vm._e()
                ],
                2
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-md-12 input-area" },
          [
            _c("label", { attrs: { for: "custom-recipients" } }, [
              _vm._v("\n                Send To\n                "),
              _vm.$userIsAdmin()
                ? _c(
                    "a",
                    {
                      directives: [
                        {
                          name: "b-toggle",
                          rawName: "v-b-toggle.collapse-email-input",
                          modifiers: { "collapse-email-input": true }
                        }
                      ]
                    },
                    [_vm._v("[new email]")]
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _c(
              "b-collapse",
              {
                attrs: {
                  id: "collapse-email-input",
                  visible: !_vm.$userIsAdmin()
                }
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.customRecipients,
                      expression: "customRecipients"
                    }
                  ],
                  staticClass: "textbox",
                  attrs: {
                    type: "text",
                    name: "userName",
                    placeholder: "Input emails separated by commas.",
                    id: "custom-recipients"
                  },
                  domProps: { value: _vm.customRecipients },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.customRecipients = $event.target.value
                    }
                  }
                })
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.viewListOfUsers
        ? _c("b-table", {
            staticClass: "list-table",
            attrs: {
              "sort-by": _vm.sort_by,
              "sort-desc": _vm.sort_desc,
              fields: _vm.fields,
              items: _vm.users,
              "show-empty": ""
            },
            on: {
              "update:sortBy": function($event) {
                _vm.sort_by = $event
              },
              "update:sort-by": function($event) {
                _vm.sort_by = $event
              },
              "update:sortDesc": function($event) {
                _vm.sort_desc = $event
              },
              "update:sort-desc": function($event) {
                _vm.sort_desc = $event
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "empty",
                  fn: function(scope) {
                    return [
                      _vm._v(
                        "\n            Search below to add users.\n        "
                      )
                    ]
                  }
                },
                {
                  key: "cell(checkbox)",
                  fn: function(data) {
                    return [
                      _c("i", {
                        staticClass: "fa fa-times text-danger cursor-pointer",
                        attrs: { title: "Remove from list" },
                        on: {
                          click: function($event) {
                            return _vm.removeUser(data.item.id)
                          }
                        }
                      })
                    ]
                  }
                },
                {
                  key: "cell(region)",
                  fn: function(data) {
                    return [
                      data.item.region && data.item.region.name
                        ? _c("span", [_vm._v(_vm._s(data.item.region.name))])
                        : _vm._e()
                    ]
                  }
                },
                {
                  key: "cell(assignedrep)",
                  fn: function(data) {
                    return [
                      data.item.sales_rep && data.item.sales_rep.name
                        ? _c("span", [_vm._v(_vm._s(data.item.sales_rep.name))])
                        : _vm._e()
                    ]
                  }
                }
              ],
              null,
              false,
              35336300
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-6 input-area" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.userName,
                expression: "userName"
              }
            ],
            ref: "user_search_input",
            staticClass: "textbox",
            attrs: {
              type: "text",
              name: "userName",
              placeholder: "Start typing to search",
              id: "userName"
            },
            domProps: { value: _vm.userName },
            on: {
              keyup: function($event) {
                return _vm.getUsers()
              },
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.userName = $event.target.value
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6 input-area" }, [
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-md-6" },
                [
                  _c(
                    "b-checkbox",
                    {
                      on: { change: _vm.getUsers },
                      model: {
                        value: _vm.filterByRep,
                        callback: function($$v) {
                          _vm.filterByRep = $$v
                        },
                        expression: "filterByRep"
                      }
                    },
                    [_vm._v("Filter by rep")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.repList && _vm.repList.length
                ? _c(
                    "div",
                    { staticClass: "col-md-6" },
                    [
                      _c(
                        "b-checkbox",
                        {
                          model: {
                            value: _vm.sendFromRep,
                            callback: function($$v) {
                              _vm.sendFromRep = $$v
                            },
                            expression: "sendFromRep"
                          }
                        },
                        [_vm._v("Send from rep")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.repList && _vm.repList.length
                ? _c(
                    "div",
                    { staticClass: "col-md-12" },
                    [
                      _vm.sendFromRep
                        ? _c(
                            "b-select",
                            {
                              attrs: {
                                options: _vm.repList,
                                "text-field": "name",
                                "value-field": "id"
                              },
                              model: {
                                value: _vm.fromRep,
                                callback: function($$v) {
                                  _vm.fromRep = $$v
                                },
                                expression: "fromRep"
                              }
                            },
                            [
                              _c(
                                "b-form-select-option",
                                { attrs: { value: null, disabled: "" } },
                                [_vm._v("-- Select from rep --")]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.getUserList && _vm.getUserList.length
        ? _c(
            "div",
            { staticClass: "row user-detail" },
            _vm._l(_vm.getUserList, function(user) {
              return _c("div", { staticClass: "col-md-12" }, [
                _c("div", { staticClass: "row detail" }, [
                  _c("div", { staticClass: "col-md-6" }, [
                    _c("span", { staticClass: "member-name" }, [
                      _vm._v(_vm._s(user.name))
                    ]),
                    _vm._v(" "),
                    user.company
                      ? _c("span", [
                          _vm._v("(" + _vm._s(user.company.name) + ")")
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-6 link" }, [
                    _c(
                      "a",
                      {
                        staticClass: "save-list",
                        on: {
                          click: function($event) {
                            return _vm.saveToList(user)
                          }
                        }
                      },
                      [_vm._v("Add")]
                    )
                  ])
                ])
              ])
            }),
            0
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-31eea46c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31eea46c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/VehicleSendOfferModal.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-31eea46c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/VehicleSendOfferModal.vue
// module chunks = 0